import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import AppStagesColumns from './appStagesColumns';
import StyledWrapper from './style';

import Table from '../../../../components/Table/Table';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const AppStagesTable = ({ data, handleAlert }) => {
	const [searchParams] = useSearchParams();
	const [columnWidth, setColumnWidth] = useState({});
	const [filterModel, setFilterModel] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [loadingCancel, setLoadingCancel] = useState(false);

	const initialColumns = AppStagesColumns(columnWidth, handleAlert);

	const groupingColDef = () => ({
		resizable: false,
		minWidth: 0,
		width: 0
	});

	// Constants
	const getTreeDataPath = (row) => row.hierarchy;

	useEffect(() => {
		setRefresh(!refresh);
	}, [data, searchParams]);

	useEffect(() => {
		setLoadingCancel(true);
		setTimeout(function () {
			setLoadingCancel(false);
		}, 1000);
	}, [location.pathname]);

	return (
		<>
			{loadingCancel ? (
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<CircularProgress />
				</Box>
			) : (
				<StyledWrapper.TableContainer>
					<Table
						style={{ margin: 'auto' }}
						enableAutoPageSize
						treeData
						getTreeDataPath={getTreeDataPath}
						disableSelectionOnClick
						columns={initialColumns}
						rows={data}
						groupingColDef={() => groupingColDef()}
						rowHeight={true}
						hideTableActions={true}
						filterModel={filterModel}
						onFilterModelChange={setFilterModel}
						onColumnResize={(e) => {
							const newColumnSizes = e?.colDef?.field;
							const width = e?.width;
							setColumnWidth({ ...columnWidth, [newColumnSizes]: width });
						}}
					/>
				</StyledWrapper.TableContainer>
			)}
		</>
	);
};

export default AppStagesTable;
